import { useRouter } from 'next/router'
import React from 'react'
import { ArcadeMachineDetailPage } from '../../../components/pages/ArcadeMachineDetailPage'

const Page = () => {
  const { arcadeMachineId = '' } = useRouter().query as NodeJS.Dict<string>
  return <ArcadeMachineDetailPage arcadeMachineId={arcadeMachineId} />
}

export default Page
